module.exports = async function(context) {
  var dashboardApi = (context || {}).dashboardApi;
  if (!(dashboardApi)) return;

  var scopeSel = document.getElementById("app-config-scope");
  var envSel = document.getElementById("app-config-env");
  var searchInput = document.getElementById("app-config-search");
  var pageSizeSel = document.getElementById("app-config-page-size");
  var refreshBtn = document.getElementById("app-config-refresh");
  var listHost = document.getElementById("app-config-list");
  var countHost = document.getElementById("app-config-count");
  var prevBtn = document.getElementById("app-config-prev");
  var nextBtn = document.getElementById("app-config-next");
  var fieldMeta = document.getElementById("app-config-field-meta");
  var useDefaultWrap = document.getElementById("app-config-default-wrap");
  var useDefaultInput = document.getElementById("app-config-use-default");
  var fieldEditor = document.getElementById("app-config-field-editor");
  var saveFieldBtn = document.getElementById("app-config-save-field");
  var jsonEditor = document.getElementById("app-config-json-editor");
  var saveJsonBtn = document.getElementById("app-config-save-json");
  var backupsSel = document.getElementById("app-config-backups");
  var revertBtn = document.getElementById("app-config-revert");
  var resultNode = document.getElementById("app-config-result");
  var previewNode = document.getElementById("app-config-preview");

  if (!(scopeSel && envSel && listHost && fieldEditor && saveFieldBtn && jsonEditor && saveJsonBtn && backupsSel && revertBtn)) return;

  var configState = {
    environment: "dev",
    scope: "env",
    definitions: [],
    filtered: [],
    byPath: {},
    selectedPath: "",
    targetConfig: {},
    page: 1
  };

  function setResult(html) {
    resultNode.innerHTML = html || "";
  }

  function setPreview(value) {
    previewNode.textContent = value || "";
  }

  async function postConfig(action, payload) {
    var response = await fetch("/api/platform.app.config/" + action, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload || {})
    });
    var body = await response.json();
    if (!(response.ok) || !(body && body.success)) {
      var err = ((body || {}).errors || [body])[0] || { description: "Request failed." };
      throw err;
    }
    return body.data || {};
  }

  function escapeHtml(value) {
    return (value || "").toString()
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/\"/g, "&quot;");
  }

  function parseControlValue(definition, rawValue) {
    var typeName = ((definition || {}).type || "").toString().toLowerCase();
    if (typeName === "boolean") return !!rawValue;
    if (typeName === "number" || typeName === "integer") {
      var num = Number(rawValue);
      if (!(Number.isFinite(num))) throw new Error("Value must be a valid number.");
      return num;
    }
    return (rawValue || "").toString();
  }

  function getTargetConfigFromRepo(data) {
    if ((scopeSel.value || "env") === "default") return (data.defaultConfig || {});
    return (data.envConfig || {});
  }

  async function renderPropertyEditor(pathValue) {
    fieldEditor.innerHTML = "";
    var definition = configState.byPath[pathValue] || null;
    if (!(definition)) {
      fieldMeta.innerHTML = "<span class='text-danger'>Property definition was not found.</span>";
      if (useDefaultWrap) useDefaultWrap.classList.add("d-none");
      return;
    }

    var title = escapeHtml(definition.title || definition.path || "");
    var desc = escapeHtml(definition.description || "");
    var typeText = escapeHtml(definition.type || definition.inferredType || "string");
    var restrictedText = definition.restricted ? "Yes" : "No";
    fieldMeta.innerHTML = "<strong>" + title + "</strong> <span class='text-muted'>(" + typeText + ")</span>"
      + (desc ? "<div class='text-muted'>" + desc + "</div>" : "")
      + "<div class='text-muted'>Path: <code>" + escapeHtml(definition.path || "") + "</code> | Restricted: " + restrictedText + "</div>";

    if (useDefaultWrap && useDefaultInput) {
      var allowDefault = ((scopeSel.value || "env") === "env");
      if (allowDefault) {
        useDefaultWrap.classList.remove("d-none");
        useDefaultInput.checked = !!definition.useDefault;
      } else {
        useDefaultWrap.classList.add("d-none");
        useDefaultInput.checked = false;
      }
    }

    if (useDefaultInput && ((scopeSel.value || "env") === "env") && useDefaultInput.checked) {
      fieldEditor.innerHTML = "<div class='alert alert-info mb-0'>This property is using the default value. Uncheck to create an environment override.</div>";
      return;
    }

    if (definition.control === "json") {
      fieldEditor.innerHTML = "<div class='alert alert-info mb-0'>This property is object/list typed. Edit it in the JSON Editor tab.</div>";
      return;
    }

    var controlName = "app_config_property_value";
    var controlJson = null;
    if (definition.control === "switch") {
      controlJson = {
        n: "ua.switch",
        name: controlName,
        title: definition.title || definition.path || "Value",
        value: !!definition.value
      };
    } else {
      controlJson = {
        n: "ua.input",
        name: controlName,
        title: definition.title || definition.path || "Value",
        type: (definition.control === "number" ? "number" : "text"),
        required: false,
        value: (definition.value == null ? "" : String(definition.value))
      };
    }

    var rendered = await window.UATools.render(controlJson);
    if (typeof rendered === "string") {
      fieldEditor.innerHTML = rendered;
      return;
    }
    if (rendered && rendered.nodeType) {
      fieldEditor.appendChild(rendered);
    }
  }

  function filterDefinitions(rows) {
    var list = rows instanceof Array ? rows : [];
    var search = ((searchInput && searchInput.value) || "").toString().trim().toLowerCase();
    if (!(search)) return list;
    return list.filter(function(row) {
      var txt = [
        (row.path || ""),
        (row.title || ""),
        (row.description || "")
      ].join(" ").toLowerCase();
      return txt.indexOf(search) >= 0;
    });
  }

  function renderList() {
    var rows = configState.filtered || [];
    var pageSize = Math.max(1, Number((pageSizeSel && pageSizeSel.value) || 25));
    var pageCount = Math.max(1, Math.ceil(rows.length / pageSize));
    if (configState.page > pageCount) configState.page = pageCount;
    if (configState.page < 1) configState.page = 1;

    var start = (configState.page - 1) * pageSize;
    var end = start + pageSize;
    var pageRows = rows.slice(start, end);

    if (countHost) {
      countHost.textContent = "Showing " + (rows.length === 0 ? 0 : (start + 1)) + "-" + Math.min(end, rows.length) + " of " + rows.length + " settings (page " + configState.page + " of " + pageCount + ")";
    }

    if (prevBtn) prevBtn.disabled = configState.page <= 1;
    if (nextBtn) nextBtn.disabled = configState.page >= pageCount;

    if (!(listHost)) return;
    if (pageRows.length === 0) {
      listHost.innerHTML = "<div class='list-group-item text-muted'>No settings match the current filter.</div>";
      configState.selectedPath = "";
      renderPropertyEditor("");
      return;
    }

    var html = "";
    for (var i = 0; i < pageRows.length; i++) {
      var row = pageRows[i] || {};
      var active = (row.path || "") === (configState.selectedPath || "");
      var defaultBadge = ((scopeSel.value || "env") === "env")
        ? (row.useDefault ? "<span class='badge bg-secondary ms-2'>Default</span>" : "<span class='badge bg-primary ms-2'>Override</span>")
        : "";
      html += "<button type='button' class='list-group-item list-group-item-action " + (active ? "active" : "") + "' data-config-path='" + escapeHtml(row.path || "") + "'>";
      html += "<div class='d-flex w-100 justify-content-between'>";
      html += "<strong>" + escapeHtml(row.title || row.path || "") + "</strong>";
      html += "<small>" + escapeHtml(row.type || "") + "</small>";
      html += "</div>";
      html += "<div><code>" + escapeHtml(row.path || "") + "</code>" + defaultBadge + "</div>";
      if (row.description) html += "<div class='small text-muted'>" + escapeHtml(row.description) + "</div>";
      html += "</button>";
    }
    listHost.innerHTML = html;

    var buttons = listHost.querySelectorAll("button[data-config-path]");
    for (var b = 0; b < buttons.length; b++) {
      buttons[b].addEventListener("click", async function() {
        configState.selectedPath = this.getAttribute("data-config-path") || "";
        renderList();
        await renderPropertyEditor(configState.selectedPath);
      });
    }

    var selectedInPage = false;
    for (var r = 0; r < pageRows.length; r++) {
      if ((pageRows[r].path || "") === (configState.selectedPath || "")) {
        selectedInPage = true;
        break;
      }
    }
    if (!(selectedInPage)) {
      configState.selectedPath = pageRows[0].path || "";
    }
  }

  function updateBackups(backups) {
    backupsSel.innerHTML = "";
    var rows = backups instanceof Array ? backups : [];
    if (rows.length === 0) {
      var empty = document.createElement("option");
      empty.value = "";
      empty.textContent = "No backups yet";
      backupsSel.appendChild(empty);
      backupsSel.disabled = true;
      revertBtn.disabled = true;
      return;
    }

    backupsSel.disabled = false;
    revertBtn.disabled = false;
    for (var i = 0; i < rows.length; i++) {
      var item = rows[i] || {};
      var option = document.createElement("option");
      option.value = item.id || "";
      option.textContent = (item.id || "") + " (" + (item.createdOn || "") + ")";
      backupsSel.appendChild(option);
    }
  }

  async function loadEnvironments() {
    var list = await dashboardApi.list("platform.app.config", {}, 1, { by: "name", dir: "asc" }, 50);
    var envs = (((list || {}).data || {}).environments || []);
    if (!(envs instanceof Array) || envs.length === 0) envs = ["dev"];
    envSel.innerHTML = "";
    for (var i = 0; i < envs.length; i++) {
      var option = document.createElement("option");
      option.value = envs[i];
      option.textContent = envs[i];
      envSel.appendChild(option);
    }
  }

  async function loadConfigAuto() {
    setResult("");
    envSel.disabled = (scopeSel.value === "default");
    var payload = {
      id: envSel.value || "dev",
      env: envSel.value || "dev",
      scope: scopeSel.value || "env"
    };
    var data = await postConfig("get", payload);

    configState.environment = data.environment || (envSel.value || "dev");
    configState.scope = scopeSel.value || "env";
    configState.definitions = (data.definitions || []);
    configState.filtered = filterDefinitions(configState.definitions);
    configState.byPath = {};
    for (var i = 0; i < configState.definitions.length; i++) {
      var row = configState.definitions[i] || {};
      configState.byPath[row.path || ""] = row;
    }
    configState.targetConfig = getTargetConfigFromRepo(data);

    setPreview(JSON.stringify(data.effectiveConfig || {}, null, 2));
    jsonEditor.value = JSON.stringify(configState.targetConfig || {}, null, 2);
    updateBackups(data.backups || []);
    renderList();
    if (!(configState.selectedPath) && configState.filtered.length > 0) {
      configState.selectedPath = (configState.filtered[0] || {}).path || "";
    }
    await renderPropertyEditor(configState.selectedPath);
  }

  scopeSel.addEventListener("change", async function() {
    try {
      await loadConfigAuto();
    } catch (error) {
      setResult("<div class='text-danger'>Unable to load configuration.</div>");
    }
  });

  envSel.addEventListener("change", async function() {
    try {
      await loadConfigAuto();
    } catch (error) {
      setResult("<div class='text-danger'>Unable to load configuration.</div>");
    }
  });

  if (searchInput) {
    searchInput.addEventListener("input", async function() {
      configState.page = 1;
      configState.filtered = filterDefinitions(configState.definitions);
      renderList();
      if (!(configState.byPath[configState.selectedPath])) {
        configState.selectedPath = ((configState.filtered[0] || {}).path || "");
      }
      await renderPropertyEditor(configState.selectedPath);
    });
  }

  if (pageSizeSel) {
    pageSizeSel.addEventListener("change", function() {
      configState.page = 1;
      renderList();
    });
  }

  if (prevBtn) {
    prevBtn.addEventListener("click", function() {
      if (configState.page > 1) {
        configState.page -= 1;
        renderList();
      }
    });
  }

  if (nextBtn) {
    nextBtn.addEventListener("click", function() {
      configState.page += 1;
      renderList();
    });
  }

  if (refreshBtn) {
    refreshBtn.addEventListener("click", async function() {
      try {
        await loadConfigAuto();
      } catch (error) {
        setResult("<div class='text-danger'>Unable to refresh configuration.</div>");
      }
    });
  }

  if (useDefaultInput) {
    useDefaultInput.addEventListener("change", async function() {
      await renderPropertyEditor(configState.selectedPath);
    });
  }

  saveFieldBtn.addEventListener("click", async function() {
    try {
      var pathValue = configState.selectedPath || "";
      var definition = configState.byPath[pathValue];
      if (!(definition)) {
        setResult("<div class='text-danger'>No property selected.</div>");
        return;
      }

      if (useDefaultInput && ((scopeSel.value || "env") === "env") && useDefaultInput.checked) {
        var resetResult = await postConfig("save", {
          data: {
            target: {
              scope: scopeSel.value || "env",
              env: envSel.value || "dev"
            },
            changes: [{
              path: pathValue,
              useDefault: true
            }]
          }
        });
        var deniedReset = (resetResult.denied || []);
        if (deniedReset.length > 0) {
          setResult("<div class='text-warning'>Saved with restrictions. Denied: " + deniedReset.map(function(item) { return item.path; }).join(", ") + "</div>");
        } else {
          setResult("<div class='text-success'>Default behavior restored for property.</div>");
        }
        await loadConfigAuto();
        return;
      }

      if (definition.control === "json") {
        setResult("<div class='text-warning'>Use JSON Editor for object/list properties.</div>");
        return;
      }

      var saveRepo = await window.UATools.save("#app-config-field-editor", true);
      if (!(saveRepo && saveRepo.success && saveRepo.app_config_property_value && saveRepo.app_config_property_value.success)) {
        setResult("<div class='text-danger'>Property input is invalid.</div>");
        return;
      }

      var rawValue = saveRepo.app_config_property_value.data;
      var parsedValue = parseControlValue(definition, rawValue);
      var result = await postConfig("save", {
        data: {
          target: {
            scope: scopeSel.value || "env",
            env: envSel.value || "dev"
          },
          changes: [{
            path: pathValue,
            value: parsedValue
          }]
        }
      });

      var denied = (result.denied || []);
      if (denied.length > 0) {
        setResult("<div class='text-warning'>Saved with restrictions. Denied: " + denied.map(function(item) { return item.path; }).join(", ") + "</div>");
      } else {
        setResult("<div class='text-success'>Property saved.</div>");
      }
      await loadConfigAuto();
      configState.selectedPath = pathValue;
      await renderPropertyEditor(pathValue);
    } catch (error) {
      setResult("<div class='text-danger'>Unable to save property.</div>");
    }
  });

  saveJsonBtn.addEventListener("click", async function() {
    try {
      var parsed = JSON.parse(jsonEditor.value || "{}");
      var result = await postConfig("save", {
        data: {
          target: {
            scope: scopeSel.value || "env",
            env: envSel.value || "dev"
          },
          replace: true,
          config: parsed
        }
      });

      var denied = (result.denied || []);
      if (denied.length > 0) {
        setResult("<div class='text-warning'>Saved with restrictions. Denied: " + denied.map(function(item) { return item.path; }).join(", ") + "</div>");
      } else {
        setResult("<div class='text-success'>JSON saved.</div>");
      }
      await loadConfigAuto();
    } catch (error) {
      setResult("<div class='text-danger'>Unable to save JSON configuration.</div>");
    }
  });

  revertBtn.addEventListener("click", async function() {
    try {
      var id = backupsSel.value || "";
      if (!(id)) {
        setResult("<div class='text-danger'>Select a backup first.</div>");
        return;
      }
      await postConfig("revert", {
        data: {
          id: id,
          target: {
            scope: scopeSel.value || "env",
            env: envSel.value || "dev"
          }
        }
      });
      setResult("<div class='text-success'>Configuration reverted from backup.</div>");
      await loadConfigAuto();
    } catch (error) {
      setResult("<div class='text-danger'>Unable to revert backup.</div>");
    }
  });

  try {
    await loadEnvironments();
    await loadConfigAuto();
  } catch (error) {
    setResult("<div class='text-danger'>Unable to load app configuration.</div>");
  }
};
